import {dispatch} from 'od-modules/secure_store/store';
import {SET_MEMBERSHIP_INFO, SET_MEMBERSHIP_SUBSCRIPTION_OFFER} from 'od-modules/secure_store/actions';

export default {
    getUrl() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')('activate-membership-auto-renewal');
    },
    getMethod() {
        return 'PUT';
    },
    requestSuccess(data) {
        Odigeo.trigger('activateMembershipAutoRenewalOk', data);
        if (data && Odigeo.Utils.getCurrentPath().indexOf('/secure') !== -1) {
            dispatch({type: SET_MEMBERSHIP_INFO, entry: data});
            dispatch({type: SET_MEMBERSHIP_SUBSCRIPTION_OFFER, entry: {reactivatePrime: false}, merge: true});
        }
        return data;
    },
    requestError(error) {
        Odigeo.trigger('activateMembershipAutoRenewalFail', error);
    },
};
